import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import styled from "styled-components";
import { Button } from "../components/ui";

const LogoutBtnFC = () => {
  const { logout } = useAuth0();

  return (
    <LogoutButtonContainer>
      <Button
        variant="subtle"
        size="medium"
        onClick={() => logout({ returnTo: window.location.origin })}
      >
        Logout
      </Button>
    </LogoutButtonContainer>
  );
};

const LogoutButtonContainer = styled.div`
  display: block;
  position: static;
`;

export default LogoutBtnFC;
